// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';

export const AlertBarMessageList = props => (
    <ul className='alert-bar-message-list'>{
        props.messages.map((message, index) => (
            <li key={index}>{message.message}</li>
        ))
    }</ul>
);

AlertBarMessageList.displayName = 'AlertBarMessageList';

AlertBarMessageList.propTypes = {
    messages: PropTypes.arrayOf(
        PropTypes.shape({
            message: PropTypes.any.isRequired
        })
    ).isRequired
};



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar-container/alert-bar-message-list.js